import { useEffect, useState } from 'react';

import Image from 'react-bootstrap/Image';

import Menu from '../../components/MenuA2A2';

import header from '../../images/selo_a2a2_original.png'

import constantes from '../../helpers/constanteHelper';

function SobreA2A2() {
    const [width, setWidth] = useState(window.innerWidth);


    function observarMudancaWidth() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', observarMudancaWidth);

        // Scroll para o topo da página para melhor visualização no mobile ou em resoluções menores
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

        return () => {
            window.removeEventListener('resize', observarMudancaWidth);
        }
    }, []);

    const resolucaoMobile = width <= constantes.RESPONSIVIDADE.LARGURA_MOBILE;

    return (
        <>
            <div style={{ minHeight: '100vh', background: constantes.CORES.AZUL_A2A2 }} className='text-center d-flex flex-column align-items-center'>
                <Menu opcaoSelecionada={'sobre'} />
                <div className='animate__animated animate__fadeIn d-flex flex-column align-items-center'>
                    <div style={{ height: resolucaoMobile ? '20px' : '80px' }}></div>

                    <Image style={{ height: '500px', objectFit: 'contain', padding: '20px' }} src={header} alt='logo' fluid />
                    <h1 className={resolucaoMobile ? 'mb-5' : 'mt-5 mb-5'} style={{ color: constantes.CORES.BRANCO_PADRAO, fontWeight: 700 }}>Certificação Vacas A2A2</h1>

                    <span className='mb-5' style={{ width: resolucaoMobile ? '90vw' : '70vw', color: constantes.CORES.BRANCO_PADRAO, fontSize: '20px', whiteSpace: 'pre-line', textAlign: resolucaoMobile ? 'justify' : 'center' }}>
                        O programa de Certificação Vacas A2A2 foi o primeiro protocolo de rastreabilidade da pecuária leiteira registrado da Confederação Nacional da Agricultura (CNA), o que garante ainda mais robustez, transparência e confiabilidade ao mercado de leite proveniente de Vacas A2A2 no Brasil.<br/><br/>
                        Este programa foi baseado em pesquisas desenvolvidas por Universidades e Instituições brasileiras e internacionais. As auditorias são feitas por entidades certificadoras acreditadas internacionalmente, pelo International Accreditation Forum (IAF).<br/><br/>
                        A Certificação Vacas A2A2 é independente e de adesão voluntária e utiliza a Certificação de Terceira Parte, que tem como objetivo verificar se um determinado sistema de gerenciamento ou procedimento foi estabelecido, está documentado, implementado e mantido de acordo com normas e escopos específicos.<br/><br/>
                    </span>

                </div>
            </div>
        </>
    );
}

export default SobreA2A2;
